import http from '../http-common';
import { User } from '../types/global';
import { useAuth } from '../provider/AuthProvider';

const getAllUsers = () => {
    return http.get<Array<User>>('/users');
}

const deleteUser = async (_id: string) => {
    try {
        const response = await http.delete(`/users/${_id}`);
        return response.data;
    } catch (error) {
        console.log('error while deleting user', error);
        throw error;
    }
}

const createUser = async (submitData: FormData) => {
    try {
        const response = await http.post('/createuser', submitData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to save the user.', error);
        throw error;
    }
}

const updateUser = async (_id: string, submitData: FormData) => {
    try {
        const response = await http.patch(`/users/${_id}`, submitData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        console.log('Failed to update the user', _id);
        throw error;
    }
}

const login = async (email: string, password: string) => {
    try {
        const response = await http.post('/auth/loginv2', { email, password }, { withCredentials: true });
        return response.data.accessToken;
    } catch (error) {
        console.error('Login failed:', error);
        throw error;
    }
};

const UserDataService = {
    getAllUsers,
    deleteUser,
    createUser,
    updateUser,
    login
};

export default UserDataService;